<template>
  <div class="form-group document-check-list-item">
    <h5 class="uk-text-bold mb-2">
      {{ $t('general.explanatory_text') }} <span class="required">*</span>
    </h5>
    <textarea 
      :value="description"
      @input="$emit('update:description', $event.target.value)"
      class="form-control" 
      name="short_description"
    ></textarea>
    
    <form v-for="(item, index) in items" :key="index" class="mt-4">
      <h5 class="uk-text-bold mb-2">
        <i class="uil-check-square"></i> {{ index + 1 }}.
        {{ $t('general.control_article') }}
        <span class="required">*</span>
      </h5>
      <div class="row">
        <div class="col-md-8">
          <input 
            :value="item.name"
            @input="updateItemName(index, $event.target.value)"
            class="form-control" 
            type="text" 
            @keydown.enter="onEnter"
          />
        </div>
        <div class="col-md-4" style="text-align: end">
          <!-- uk-grid YOK: UIkit JS sarma algilayip butona `uk-grid-margin`
               (margin-top: 30px) ekliyor ve alt satira itiyordu. Kapta zaten
               d-flex + justify-content-between var, grid'e gerek yok.
               uk-width-auto / uk-width-expand grid'den bagimsiz calisir. -->
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="uk-width-auto">
                <label class="uk-switch mb-0">
                  <input 
                    :checked="item.is_mandatory"
                    @change="updateItemMandatory(index, $event.target.checked)"
                    type="checkbox" 
                  />
                  <div class="uk-switch-slider uk-switch-small"></div>
                </label>
              </div>
              <div class="uk-width-expand">
                <small class="ml-2">{{$t('general.mandatory_to_mark')}}</small>
              </div>
            </div>
            <i
              class="uil-trash check-list-remove"
              :uk-tooltip="'title: ' + $t('general.remove')"
              @click="$emit('remove-item', index)"
            ></i>
          </div>
        </div>
      </div>
    </form>
    
    <div class="mt-3">
      <button 
        class="uk-button uk-button-outline" 
        style="width: 100%" 
        type="button"
        @click="$emit('add-item')"
      >
        <i class="uil-plus"></i> {{ $t('general.add_control') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentCheckListItem",
  props: {
    description: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onEnter(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    updateItemName(index, value) {
      const updatedItems = [...this.items];
      updatedItems[index] = {
        ...updatedItems[index],
        name: value
      };
      this.$emit('update:items', updatedItems);
    },
    updateItemMandatory(index, value) {
      const updatedItems = [...this.items];
      updatedItems[index] = {
        ...updatedItems[index],
        is_mandatory: value
      };
      this.$emit('update:items', updatedItems);
    }
  }
};
</script>

<style scoped>
.check-list-remove {
  flex-shrink: 0;
  padding: 8px;
  color: #64748b;
  font-size: 26px;
  width: 48px;
  height: 48px;
  line-height: 1;
  cursor: pointer;
}

/* Glyph ayni kalsin ama dokunma hedefi 48px olsun */
@media (max-width: 959px) {
  .check-list-remove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    padding: 0;
  }
}

@media (hover: hover) and (pointer: fine) {
  .check-list-remove:hover {
    color: #dc3545;
  }
}
</style>

